var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 -2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0,
    width: 21,
    height: 20,
    rx: 10,
    fill: "#30313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.37388C14.8472 8.27195 14.3369 7.25093 13.5479 6.46811C12.7589 5.68528 11.7348 5.18408 10.6335 5.04171C9.53224 4.89934 8.41476 5.12369 7.45325 5.68022C6.49174 6.23674 5.73953 7.09456 5.3125 8.12153M5 5.61682V8.12153H7.5M5 10.6261C5.15285 11.7281 5.66308 12.7491 6.4521 13.5319C7.24112 14.3147 8.26515 14.8159 9.36646 14.9583C10.4678 15.1007 11.5852 14.8763 12.5467 14.3198C13.5083 13.7633 14.2605 12.9054 14.6875 11.8785M15 14.3832V11.8785H12.5",
    stroke: "#00C3F0",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/refresh-button.2ab99ffb8a42fb41ca21dc59120b4b6a.svg";
export { ForwardRef as ReactComponent };